var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label === 'dft ')?_c('v-chip',{attrs:{"small":"","outlined":""}},[_vm._v(_vm._s(_vm.$t("global.concepts.default")))]):_c('v-chip',{attrs:{"color":_vm.colorHex,"dark":"","small":""}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }